import { API_URL, jwtToken } from "../../../context/appContext";
export default async function deleteProfile(id) {
    return fetch(`${API_URL}/api/profile/${id}`, {
        method: "DELETE",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + jwtToken
        }
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => console.log({ err }))
}
